import menu_data from "@/data/menu-data";
import Link from "@/components/common/Link";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useI18n } from "@/common/I18nProvider";
import Image from "@/components/common/Image";

export default function Navmenu() {
  const location = useLocation();
  const { messages } = useI18n();
  const menuItems = messages.menu?.items || menu_data;
  const about = messages.about;
  const [navTitle, setNavTitle] = useState<string>("");
  const [navTitle2, setNavTitle2] = useState<string>("");

  const logoSrc = "/assets/img/core-img/logo-w.svg";

  const openMobileMenu = (menu: string) => {
    setNavTitle(menu);
  };
  const closeMobileMenu = () => {
    setNavTitle("");
  };

  const openMobileMenu2 = (menu: string) => {
    setNavTitle2(menu);
  };
  const closeMobileMenu2 = () => {
    setNavTitle2("");
  };

  const isActive = (link: string) => {
    if (link === "/") return location.pathname === "/";
    return location.pathname.startsWith(link);
  };

  return (
    <>
      {/* Logo in Menu - Visible only in mobile menu */}
      <div className="menu-logo-wrapper w-100 d-flex justify-content-center mb-4 mb-xl-0">
        <Link className="navbar-brand menu-logo d-flex align-items-center" href="/">
          <Image
            className="navbar-logo w-auto h-auto"
            src={logoSrc}
            alt={about.companyName}
            width={1898}
            height={1023}
            priority
            style={{ maxHeight: "50px", width: "auto" }}
          />
        </Link>
      </div>
      <ul className="navbar-nav align-items-xl-center navbar-nav-scroll mt-4 mt-xl-0 modern-nav-menu">
      {menuItems.map((item: any, i: number) => (
        <li
          key={i}
          className="nav-item modern-nav-item"
          onMouseEnter={() => openMobileMenu(item.title)}
          onMouseLeave={closeMobileMenu}
        >
          <Link
            href={item.link}
            className={`nav-link modern-nav-link ${isActive(item.link) ? "active" : ""}`}
          >
            <span className="nav-link-text">{item.title}</span>
            {isActive(item.link) && <span className="nav-link-indicator"></span>}
            {item.has_dropdown && (
              <i
                onClick={() =>
                  navTitle === item.title
                    ? setNavTitle("")
                    : setNavTitle(item.title)
                }
                className="ti ti-caret-down-filled nav-dropdown-icon"
              ></i>
            )}
          </Link>

          {item.has_dropdown && (
            <ul
              className={`modern-dropdown-menu ${navTitle === item.title ? "show" : ""}`}
            >
              {item.submenu?.map((sub_item: any, index: number) => (
                <li
                  key={index}
                  className="modern-dropdown-item"
                  onMouseEnter={() => openMobileMenu2(sub_item.title)}
                  onMouseLeave={closeMobileMenu2}
                >
                  <Link
                    href={sub_item.link}
                    className={`modern-dropdown-link ${isActive(sub_item.link) ? "active" : ""}`}
                  >
                    {sub_item.title}{" "}
                    {sub_item.has_inner_dropdown && (
                      <i
                        onClick={() =>
                          navTitle2 === sub_item.title
                            ? setNavTitle2("")
                            : setNavTitle2(sub_item.title)
                        }
                        className="ti ti-caret-right-filled"
                      ></i>
                    )}
                  </Link>

                  {sub_item.has_inner_dropdown && (
                    <ul
                      className={`modern-dropdown-menu inner ${navTitle2 === sub_item.title ? "show" : ""}`}
                    >
                      {sub_item.submenu?.map((inner_sub_item: any, idx: number) => (
                        <li key={idx} className="modern-dropdown-item">
                          <Link
                            href={inner_sub_item.link}
                            className={`modern-dropdown-link ${isActive(inner_sub_item.link) ? "active" : ""}`}
                          >
                            {inner_sub_item.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
    </>
  );
}